import { __assign, __rest } from "tslib";
import React from 'react';
export var SquareShape = function (_a) {
    var size = _a.size, rest = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", enableBackground: "new 0 0 24 24", viewBox: "0 0 24 24", width: size, height: size }, rest),
        React.createElement("rect", { width: "85%", height: "85%", x: "2", y: "2", rx: "5" })));
};
//# sourceMappingURL=SquareShape.js.map